module.exports = __webpack_public_path__ + "static/img/yigongti.e70dab3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/20250724/ruanjian/yigongti.png
// module id = h/m9
// module chunks = 37